import { z } from 'zod'

export const RegenerateTwoFactorBackupCodesDTO = z.object({
  code: z.string().min(6).max(12).optional()
})

export type RegenerateTwoFactorBackupCodesDTO = z.infer<typeof RegenerateTwoFactorBackupCodesDTO>

export function mapRegenerateTwoFactorBackupCodesToDTO (code?: string): RegenerateTwoFactorBackupCodesDTO {
  if (code == null || code.trim() === '') {
    return {}
  }

  return {
    code
  }
}
